import React, { useEffect, useState } from "react";
import "./arjunpopup.css";

export default function Arjunpopup() {
  const [anim, setAnim] = useState(false);

  useEffect(() => {
    const start = setTimeout(() => setAnim(true), 500);

    const interval = setInterval(() => {
      setAnim(false);
      setTimeout(() => setAnim(true), 50);
    }, 5000);

    return () => {
      clearTimeout(start);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={`notif-wrapper ${anim ? "anim-start" : ""}`}>
      <div
        className="ball"
        style={{ backgroundImage: "url(/Arjunnotif.jpeg)" }}
      >
        <div className="halo"></div>
        <div className="msg-count">1</div>

        <div className="notif">
          <div className="bar">
            <div className="action"></div>
            <p className="text">ASC Arjun here!</p>
          </div>
          <div className="arrow"></div>
        </div>
      </div>
    </div>
  );
}
